var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M4.69141 4.69141C1.69185 7.69097 0.00471619 11.758 0 16C0.00471619 20.242 1.69185 24.309 4.69141 27.3086C7.69097 30.3082 11.758 31.9953 16 32C20.242 31.9954 24.309 30.3082 27.3086 27.3086C30.3082 24.309 31.9954 20.242 32 16C31.9953 11.758 30.3082 7.69097 27.3086 4.69141C24.309 1.69185 20.242 0.00471619 16 0C11.758 0.00471619 7.69097 1.69185 4.69141 4.69141Z",
    fill: "#38D58A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Success",
    d: "M8.57227 16.0373L13.4107 20.8757L23.4294 10.8569",
    stroke: "white",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleCheck);
export default __webpack_public_path__ + "static/media/green-circle-check.8479049ac47950cdbf4f456193982d5f.svg";
export { ForwardRef as ReactComponent };